// extracted by mini-css-extract-plugin
export default {"title__welcome":"Index_title__welcome__SvHFN","center__logout__btn":"Index_center__logout__btn__Ll4PX","logout__btn":"Index_logout__btn__i2p03"};